module.exports = __webpack_public_path__ + "img/bottom-title.d4a2b412.png";